import { defineStore } from 'pinia'

interface UserInfo {
  nickname: string
  user_id: string
  avatar_url: string
  access_token: string
}

export const useStores = defineStore('stores', {
  state: () => ({
    userInfo: {
      access_token: '',
      user_id: '',
      nickname: '',
      avatar_url: '',
    },
  }),
  actions: {
    setUserInfo(newUserInfo: Partial<UserInfo>) {
      this.userInfo = { ...this.userInfo, ...newUserInfo }
    },
  },
})
